import {
  ReactNode,
  createContext, useMemo,
} from 'react';
import { useParams } from 'react-router-dom';
import { useLogger } from 'react-use';

import { truefileServerApi } from 'api/truefilesServerApi';
import { IApplicationModel } from 'api/types/trueFileServerTypes';
import QuerySuspense from 'components/QuerySuspense';
import { useApiQuery } from 'hooks/useApiQuery';

export interface IApplicationState {
  application?: IApplicationModel,
  refetchApplication: ()=> Promise<void>
}

export const ApplicationContext = createContext<IApplicationState>({
  application: undefined,
  refetchApplication: () => { throw new Error('REFETCH APPLICATION NOT IMPLEMENTED YET'); },
});

export default function ApplicationContextProvider({ children }: { children: ReactNode }): JSX.Element {
  const { applicationId } = useParams();

  const applicationQuery = useApiQuery({
    queryKey: ['application-context'],
    queryFn: () => truefileServerApi.GET('/api/applications/{applicationId}', {
      params: {
        path: {
          applicationId: Number(applicationId),
        },
      },
    }),
    enabled: !!applicationId,
  });

  const state = useMemo(() => ({
    application: applicationQuery.apiResult?.data,
    refetchApplication: async () => { await applicationQuery.queryResult.refetch(); },
  }), [applicationQuery.apiResult?.data, applicationQuery.queryResult]);

  useLogger('applicationContext');

  return (
    <ApplicationContext.Provider value={state}>
      <QuerySuspense queries={[applicationQuery.queryResult]}>
        {children}
      </QuerySuspense>
    </ApplicationContext.Provider>
  );
}
